import { APP_BASE_HREF } from '@angular/common';
import { Location } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'underscore';

import { CaseLockConfirmationComponent } from '../case-lock/case-lock.component';
import { ShowMessageComponent } from '../show-message/show-message.component';
import { CreateCaseComponent } from '@app/pages/queue/common/case-detail/cases/create-case/create-case.component';
import { CasesComponent } from '@app/pages/queue/common/case-detail/cases/cases.component';
import { AddFindMemberComponent } from '@app/pages/queue/common/case-detail/cases/add-find-member/add-find-member.component';
import { MessageDialogComponent } from '@app/pages/common/message-dialog/message-dialog.component';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { DialerService } from '@app/_core/services/dialer.service';
import { ManagerService } from '@app/_core/services/manager.service';
type searchParameters = {
  type: string;
  value: string;
};

@Component({
  selector: 'app-search-dialog',
  templateUrl: './search-dialog.component.html',
  styleUrls: ['./search-dialog.component.scss'],
})
export class SearchDialogComponent implements OnInit {
  @Input()
  reason: any;
  @Input()
  Heading: any;
  @Input()
  Data: any;
  @Input()
  isEmail: any;
  @Input()
  searchType = 'user';
  @Input()
  agentID = null;
  @Input()
  searchMemberObject: {};
  @Input()
  searchObject: {};
  @Input()
  addUserRequired: boolean = true;
  @Input()
  isSearchTriggered = true;
  @Input()
  hideNotFoundButton : boolean = true;
  @Output() selectedSearchedItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() notFoundAddNew: EventEmitter<any> = new EventEmitter<any>();
  @Input() isUserSelection: boolean = false;
  modalSubs: any;
  subscriptions: Subscription[] = [];
  modalRef?: BsModalRef;
  form: FormGroup;
  searchParams: any = [];
  innerHeight = 10;
  searchResult: any = [];
  originalSearchResult: any = [];
  countData: any = 0;
  selectedData: any = {};
  addSearchParameterCount: any = 0;
  addSearchParameterArray: any = [];
  addSearchParameters: any = [];
  selectedParameters: any = [];
  CaseID: any;
  userID: any;
  casesResult: any = [];
  clientAbbreviation: any = '';
  enableAddNewBtn: boolean = false;
  queueID: any;
  queueType: any;
  showElsePart: boolean = true;
  isAddNewParameter: boolean = false; 
  @Output() action = new EventEmitter();
  hideUnknownNewbtn: boolean = false
  constructor(
    public queueServices: QueuesService,
    private router: Router,
    private appService: AppService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private webStorageService: WebStorageService,
    private location: Location,
    private mainController: MainControllerComponent,
    private dialerService: DialerService,
    private managerService: ManagerService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}

  ngOnInit(): void {
   // console.log(this.Data, 'data');
   // console.log(this.searchObject);
      this.appService.adjustTimer();
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    // adding a dummy search paarameter until search params are loaded from api
    //this.addSearchParameter();
    this.loadParameters();
    // this.addSearchParameterArray.push(this.searchObject)
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueID = queueId;
    });
    this.appService.selectedQueueType.subscribe((type: any) => {
      this.queueType = type;
    });
   // console.log(this.addSearchParameterArray, 'addarray');
      if (this.queueType != 'Inbound' && this.queueType != 'Outbound' && this.queueType != 'Blended' && !this.mainController.getIsCaseUserUnmapped() && this.getAgentStatus() != 5 && this.getAgentStatus() != 8)
          this.appService.setUserStatus(6, this.queueID);
    // this.addSearchParameter();
  }

  loadParameters() {
    this.queueServices
      .GetSearchParams()
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetSearchParams');
          if (isValid) {
            // console.log("this.dataToDisplay",data)
            this.searchParams = data.Response.Data.SearchParameters;  
            this.hideUnknownNewbtn = data.Response.Data.HideUnknownNewbtn;
            this.mainController.setHideUnknownContact(this.hideUnknownNewbtn); 
            // For agent search
            if (this.searchType == 'agent') {
              this.searchParams = _.filter(this.searchParams, item => {
                return (
                  item.Value == 'ID' ||
                  item.Value == 'First Name' ||
                  item.Value == 'Last Name' ||
                  item.Value == 'Email Address'
                );
              });
            }

            const searchObject: searchParameters = {
              type: this.searchParams[0].Value,
              value: '',
            };

            if (this.agentID) {
              this.searchRecords(searchObject);
            } else {
              this.isAddNewParameter = false;
              this.addSearchParameter();
            } 
            if (this.searchObject) this.searchRecords(this.searchObject)
            else this.addSearchParameterArray[0].type = this.searchParams[0].Value; 
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  addCountryCode(phone: string): string {
    const digitsOnly = phone.replace(/\D/g, ''); // Remove non-digit characters
  
    // Check if it already starts with '1'
    if (digitsOnly.startsWith('1')) {
      return digitsOnly;
    }
  
    // Add '1' as prefix
    return '1' + digitsOnly;
  }
    searchRecords(searchParameterObject, IsDefaultCaseReadOnly=false) {
    this.CaseID = ''; 
    this.queueServices.showElsePart();
    //this.hideUnknownNewbtn =this.hideNotFoundButton;
        if (this.queueServices.GetVoicemailDetailsReply()) {
            var iszeroidsearched = false;
            this.addSearchParameterArray.forEach(item => {
                if (item.type.toLowerCase() == 'id' && item.value == '0') {
                    iszeroidsearched = true; 
                }
            });
            if (iszeroidsearched) {
                this.showPopup('Search value cannot be 0');
                return;
            }
    }
    
    if (searchParameterObject && searchParameterObject.value != null) {
      this.isSearchTriggered = true;
    }
    //Search skipped since it was not manually triggered.
    if (!this.isSearchTriggered) {
      return;
    }

    this.addSearchParameterArray.forEach(item => {
      if (item.value == '' || item.value == null) {
        this.showPopup('Search value cannot be empty');
      }
    });
    this.addSearchParameterArray.forEach(item => {
      if (item.type == '' || item.type == 'CIS ID') {
        this.addSearchParameters.push({ type: 'CIS', value: item.value?.trim() || '' });
      } else if (item.type == 'MDG ID') {
        this.addSearchParameters.push({ type: 'MDG', value: item.value?.trim() || '' });
      } else {
        if(typeof item.value === "string"){
          this.addSearchParameters.push({ ...item, value: item.value?.trim() || '' });
        }else{
          this.addSearchParameters.push({ ...item, value: item.value || '' });
        }
      }
    });
    this.addSearchParameterArray.forEach(item => {
      if(item.type == 'Phone #'){
       item.value = this.addCountryCode(item.value);
      }
    })

    console.log('Search Parameters',this.addSearchParameterArray);
    this.queueServices
      .findRecord(
        this.clientAbbreviation == 'S2U' ? this.addSearchParameters : this.addSearchParameterArray,
        this.searchType,
        false,
        IsDefaultCaseReadOnly
      )
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'FindRecord');
          if (isValid) {


            if(!IsDefaultCaseReadOnly && data?.Response?.Data?.Message === 'UnsubmittedCase' && this.queueType == 'Search'){
              const msg = `The selected case (Case ID: ${data?.Response?.Data?.CaseID}) has not yet been submitted by creator.`
              this.showPopup(msg,data?.Response?.Data?.Name,data?.Response?.Data?.Email,true);
            }

            this.addSearchParameters = [];
            this.selectedData = {};
            this.userID = null;
            if (Array.isArray(data?.Response?.Data)) {
              data.Response.Data.forEach((item: any) => {
                delete item.IndustryID;
              });
              // data.Response.Data = data.Response.Data.filter((item: any) => !item.IndustryID);
            }
            this.searchResult = data;
            this.originalSearchResult = data;
            this.enableAddNewBtn = true;
            // ONLY FOR EMAIL + SINGLE RECORD
            if (this.isEmail && this.queueServices.getEmailComposeToValue() && this.searchResult.Response.Data.length == 1) {
              this.selectedData = this.searchResult.Response.Data;
              this.GetCurrentOrSelectedRowUserID(this.searchResult.Response.Data);
              if (
                this.searchResult.Response.Data[0].UserID == 0 &&
                (this.addSearchParameterArray[0].type == 'CaseID' ||
                  this.addSearchParameterArray[0].type == 'Case ID') &&
                this.addSearchParameterArray[0].value != ''
              ) {
            
                this.CaseID = this.addSearchParameterArray[0].value;
            
              } else {
            
                this.getCaseForUser(data.Response.Data);
              }
            
              const existingEmails =
                this.queueServices.toGetEmailArrayFunction();
            
                const currentEmail = this.getEmail(this.selectedData[0]);

       const alreadyExists = existingEmails.some( x => this.getEmail(x) === currentEmail);
              if (!alreadyExists) 
                {
                this.selectedData[0].Email =
                  this.selectedData[0]?.SearchableFieldResponses
                    ?.find((x: any) => x.FieldName === 'Email:')
                    ?.Values?.[0] || '';
                this.queueServices.toAddEmailArrayFunction( this.selectedData[0]);
                }
              this.enableAddNewBtn = false;
              this.appService.setSearchParameters(this.addSearchParameterArray);
            
              this.onContinue();
              return;
            }
            if (this.searchResult.Response.Data.length == 1 || this.searchResult.Response.Data.length >= 1) {
                  this.selectedData = this.searchResult.Response.Data;
                  this.GetCurrentOrSelectedRowUserID(this.searchResult.Response.Data);
                  if (this.searchResult.Response.Data[0].UserID == 0 && (this.addSearchParameterArray[0].type == 'CaseID' || this.addSearchParameterArray[0].type == 'Case ID') && this.addSearchParameterArray[0].value != '') {
                      this.CaseID = this.addSearchParameterArray[0].value;
                  } else {
                      this.getCaseForUser(data.Response.Data);
                  }
                  //this.getCaseForUser(data.Response.Data);
                  this.enableAddNewBtn = false;
                  this.appService.setSearchParameters(this.addSearchParameterArray);
            } else if (this.searchResult.Response.Data.length == 0) {
              this.enableAddNewBtn = true;
            }
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();

    if(this.queueType != 'Inbound'){
      this.dialerService.setPhoneNo('');
      this.dialerService.setResetCallSummary(true);
    }
  }
  showPopup(msg:string,uname='',uemail='', isShowUnsubmittedCase=false) {
      const initialState = { message: msg, name:uname, email:uemail, isUnsubmittedCase:isShowUnsubmittedCase };
        const config: ModalOptions = {
          class: 'modal-sm modal-dialog-centered',
          ignoreBackdropClick: true,
          keyboard: false,
          initialState: initialState,
        };

        this.modalRef = this.modalService.show(MessageDialogComponent, config);
        const cmp = this.modalRef.content as MessageDialogComponent;
        cmp.isProceed.subscribe((data: any) => {
          if(data){
            this.searchRecords(null,true);
            this.queueServices.SetUnsubmittedCaseForReadonly(true);
          }
        });
  }
  getCaseForUser(data: any) {
    this.queueServices
      .getCaseForUser(data)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetCaseForUser');
          if (isValid) {
            this.CaseID = data.Response.Data;
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  getCases(userId: any, caseId: any) {
    const pageSize = 15;
    this.queueServices
      .getCases(userId, caseId, this.queueID, 1, '', pageSize, 1, 0)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetCases');
          if (isValid) {
            this.casesResult = data;
            this.webStorageService.setItemInSessionStorage('cases', this.casesResult);
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  onRowSelect(data: any) {}

    onContinue() {
      
      if (this.isEmail &&  this.queueServices.getEmailComposeToValue() && this.selectedData?.length) {

        this.selectedData.forEach((item: any) => {
      
          const existingEmails =
            this.queueServices.toGetEmailArrayFunction();
      
            const currentEmail = this.getEmail(item);

         const alreadyExists = existingEmails.some(x => this.getEmail(x) === currentEmail);
          if (!alreadyExists) 
            {
            item.Email =
            item?.SearchableFieldResponses
                ?.find((x: any) => x.FieldName === 'Email:')
                ?.Values?.[0] || '';
            this.queueServices.toAddEmailArrayFunction(item);
          }
        });
      }

      this.appService.setHasOpenedQNX(false);
        this.queueServices.SetvoiceMailOnSearch(true);
        this.mainController.setshowSearchDialog(false);
        if (this.selectedData && this.CaseID) {
            if (this.selectedData[0]?.CaseID == null)
                this.selectedData[0].CaseID = this.CaseID;
        }
        this.selectedSearchedItem.emit(this.selectedData);
        if(this.isUserSelection == false){
          this.appService.setIsAddNewUser(false);
        }
        this.queueServices.triggerChangeUserLabel();
        if (this.getDialerType() == 'Keypad' || this.mainController.getIsCaseUserUnmapped()) {
            this.queueServices.hideElsePart();
        }
        if (this.mainController.getIsCaseUserUnmapped()) {
            this.updateCases(this.selectedData[0].UserID, this.mainController.getUnmappedCaseID());
        }
        this.queueServices.showUserInfoTab();
        this.queueServices.setFromSearchQueue(true)
        if (this.queueType != 'Inbound') {
            this.dialerService.setPhoneNo('');
            this.dialerService.setResetCallSummary(true); 
        }

    }

    updateCases(newUser, primaryCaseID) {
        let enterRecorddet: any;
        try {
            if (this.mainController.getEnterRecord() != '') {
                enterRecorddet = new Date(this.mainController.getEnterRecord()).getTime();
            }
            
        } catch (e) { }
        let editCases = this.appService.getEditedCases();
        let editedCases = editCases ? editCases : [];
        let allCases = editedCases.filter(item => item.CaseID !== primaryCaseID).map(item => ({
            _primary_: false,
            CaseID: Number(item.CaseID) // handle CaseID or caseid
        }));
        allCases.push({
            _primary_: true,
            CaseID: parseInt(primaryCaseID)
        });
        let pl = {
            activityId: '',
            calleeUserId: this.mainController.getcurrentRecordUserID() ?? -1,
            queueId: this.queueServices.getselectedQueueId(),
            notes: '',
            callDuration: '',
            enterRecord: enterRecorddet,
            customTYLanguage: null,
            scheduledInteractionID: null,
            voicemailID: null,
            requestType: null,
            requestTypeColor: null,
            visiblefielddata: [],
            appointmentData: null,
            userInformation: null,
            cases: [],
            survey: [],
            disposition: [],
            isFreeDialer: '',
            activeController: 'Queue',
            agentHangUp: true,
            //callID: this.callID,
            callID: this.queueServices.getCallID(),
            interactionID: '',
            newUserID: newUser,
            prevUserID: this.mainController.getUnmappedUserID(),
            isUnknownUser: true,
            primaryCaseID: parseInt(primaryCaseID),
            company: this.webStorageService.getItemFromSessionStorage('company')
        };
        if (this.dialerService.IsCaseDetailFreeDial) {
            pl.userInformation = this.dialerService.getCurrentUserRecord(); 
        }
        pl.cases = allCases;
        
        this.managerService.updateCaseDetails(pl).subscribe((res: any) => {
            
        });
    }

  getActionItem() {
    const queueID = this.queueServices.getselectedQueueId();
    const userID = this.selectedData[0].UserID;
    return queueID + '-' + userID + '-' + this.CaseID;
  }

  backClicked(data: any) {
    this.searchResult = this.originalSearchResult;
    this.selectedData = {};
    this.userID = null; 
  }

  dataChange(data: any) {
    this.selectedData = data;
    this.searchResult = { Response: { Data: data } };
    this.GetCurrentOrSelectedRowUserID(this.selectedData);
    this.getCaseForUser(this.selectedData);
  }

  GetCurrentOrSelectedRowUserID(data: any) {
    if (Array.isArray(data)) {
      this.userID = data[0].UserID;
    } else {
      this.userID = data.UserID;
    }
  }

  getCaseDetails() {
    this.bsModalRef.hide();
    // this.bsModalRef.onHide.pipe()
    if (this.reason) {
      if (this.reason == 'add-record') {
        //what to do after this is not clear in old ui
        // this.bsModalRef.hide();
        const initialState = {
          reason: this.reason,
        }; 
        const config: ModalOptions = {
          backdrop: 'static',
          class: 'task-menu',
          initialState,
        };
        this.modalRef = this.modalService.show(ShowMessageComponent, config); 
      } 
    } else {
      const menuName = this.appService.getCurrentMenu().value;
      //const url = "-" + this.queueServices.getCaseDetails(menuName, this.selectedData);
      const url = '-' + this.userID + '-' + this.CaseID; 
      this.router.navigateByUrl(this.router.url + url);
      this.getCases(this.userID, this.CaseID);
    } 
  }

  addSearchParameter() {
    if (this.addSearchParameterArray[0]?.type == '') {
      this.addSearchParameterArray = [];
      const searchObject: searchParameters = {
        type: this.searchParams[0].Value,
        value: '',
      };
      this.addSearchParameterArray.push(searchObject);
    } else if (this.searchObject && !this.isAddNewParameter) {
      this.addSearchParameterArray = [];
      this.addSearchParameterArray.push(this.searchObject);
      this.isAddNewParameter = true;
    } else {
      const searchObject: searchParameters = {
        type: '',
        value: '',
      };
      this.addSearchParameterArray.push(searchObject);
    }
  }

  removeSearchParameter() {
    this.addSearchParameterArray.pop();
  }

  closeTaskSelectionMenu() {
    this.bsModalRef.hide();
  }

  goBack() {
    this.backClicked(null);
  }

  addNewUser() {
    this.notFoundAddNew.emit('not-found');
    this.mainController.setIsCaseUserUnmapped(null);
    this.mainController.setIsUnknownContact(true); 
  }

  getDialerType() {
    return this.mainController.getDialerType();
  }
  HandleSearchUserRecords() {
    const actionItem = this.getActionItem();
    this.queueServices.GetCaseLocks(this.CaseID).subscribe(data => {
      if (data.Response.Data.Agent != null) {
        this.selectedData.Locked = true;
        //set to read only mode
        this.selectedData.ActionItemID = actionItem + '-R';
        this.selectedData.LockedBy = data.Response.Data.Agent.ID;
        const initialState = {
          selectedData: this.selectedData,
        };
        const config: ModalOptions = {
          class: 'status-menu',
          backdrop: 'static',
          keyboard: false,
          initialState,
        };
        this.modalRef = this.modalService.show(CaseLockConfirmationComponent, config);
      } else {
        this.appService.setActionItemId(actionItem);
        this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
      }
    });
  }
    getAgentStatus() {
        let status = this.mainController.getAgentStatus();
        return status;
    }
  resetSearchParameter(index: number, selectedValue: any) {
    try {
      this.addSearchParameterArray[index].type = selectedValue;
      this.addSearchParameterArray[index].value = '';
    } catch (err) {
      console.error('Error in resetSearchParameter:', err);
    }
  }
  private getEmail(item: any): string {
    return item?.SearchableFieldResponses
      ?.find((x: any) => x.FieldName === 'Email:')
      ?.Values?.[0] || '';
  }
}
